import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e205e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-faq" }
const _hoisted_2 = { class: "box-banner" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "box-banner-inner" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "main" }
const _hoisted_7 = { class: "box-view" }

import { ref, provide } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRouter, useRoute } from 'vue-router';
  import { faqSectionsStore } from '@/stores';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  faqSectionsStore.fetchData();
  provide('faqSectionsStore', faqSectionsStore);

  const { t } = useI18n();
  const router = useRouter();
  const route = useRoute();
  const keyword = ref('');
  function handleSearch(keyword: string) {
    if (keyword) {
      router[route.name === 'faq.search' ? 'replace' : 'push']({ name: 'faq.search', query: { keyword } });
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_unref(t)('welcome')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AppSearch, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          placeholder: _unref(t)('search_placeholder'),
          onSearch: handleSearch
        }, null, 8, ["modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_7, [
          (_unref(faqSectionsStore).data.length)
            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
            : _createCommentVNode("", true),
          (!_unref(faqSectionsStore).data.length && _unref(faqSectionsStore).isFulfilled)
            ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})